import React from "react";
import { ProgressBar } from "react-bootstrap";

function StatisticsCard({ data }) {

    return (
        <div className="card">
            <div className="card-header py-3">
                <h6 className="mb-0 fw-bold ">Statistics</h6>
            </div>
            <div className="card-body">
                <div className="progress-count mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0 fw-bold d-flex align-items-center">Today</h6>
                        <span className="small text-muted"> {String(data?.statistics?.today?.completed).padStart(2, '0')}/{String(data?.statistics?.today?.total).padStart(2, '0')}</span>
                    </div>
                    <ProgressBar style={{ height: 10 }}>
                        <ProgressBar now={data?.statistics?.today?.percentage || 0} className="light-orange-bg" />
                    </ProgressBar>
                </div>
                <div className="progress-count mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0 fw-bold d-flex align-items-center">This Week</h6>
                        <span className="small text-muted">{String(data?.statistics?.thisWeek?.completed).padStart(2, '0')}/{String(data?.statistics?.thisWeek?.total).padStart(2, '0')}</span>
                    </div>
                    <ProgressBar style={{ height: 10 }}>
                        <ProgressBar now={data?.statistics?.thisWeek?.percentage || 0} className="bg-lightgreen" />
                    </ProgressBar>
                </div>
                <div className="progress-count mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0 fw-bold d-flex align-items-center">This Month</h6>
                        <span className="small text-muted">{String(data?.statistics?.thisMonth?.completed).padStart(2, '0')}/{String(data?.statistics?.thisMonth?.total).padStart(2, '0')}</span>
                    </div>
                    <ProgressBar style={{ height: 10 }}>
                        <ProgressBar now={data?.statistics?.thisMonth?.percentage || 0} className="bg-lightyellow" />
                    </ProgressBar>
                </div>
                <div className="progress-count mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0 fw-bold d-flex align-items-center">Over All</h6>
                        <span className="small text-muted">{String(data?.statistics?.allStatistics?.completed).padStart(2, '0')}/{String(data?.statistics?.allStatistics?.total).padStart(2, '0')}</span>
                    </div>
                    <ProgressBar style={{ height: 10 }}>
                        <ProgressBar now={data?.statistics?.allStatistics?.percentage || 0} className="light-success-bg" />
                    </ProgressBar>
                </div>
                <div className="progress-count mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0 fw-bold d-flex align-items-center">Overtime</h6>
                        <span className="small text-muted">{data?.statistics?.totalOverTime}</span>
                    </div>
                    <ProgressBar style={{ height: 10 }}>
                        <ProgressBar now={40} className="light-info-bg" />
                    </ProgressBar>
                </div>
            </div>
        </div>
    )
}


export default StatisticsCard;